import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIService } from '@core/services/api.service';
import { Utility } from '@shared/services/utility.abstract';
import { GroupParkingLot, GroupVehicleTypeDetail } from '@core/models/group-user.model';
import { ParkingLotDetail } from '@core/models/parking-detail.model';

@Injectable({
  providedIn: 'root'
})
export class GroupUserService {

  constructor(
    private readonly apiService: APIService
  ) { }

  getParkingLotsForGroupBooking(data: any): Observable<GroupParkingLot[]> {
    return this.apiService.post(`GroupBooking/GetParkingLotsForGroupBooking`, data)
  }

  getGroupBookingDetailById(id: string): Observable<GroupParkingLot[]> {
    const timeZone = Utility.getLocalTimeZone();
    return this.apiService.get(`GroupBooking/GetGroupBookingDetailById?id=${id}&timeZone=${timeZone}`)
  }

  getParkingLotsById(id: string): Observable<ParkingLotDetail> {
    return this.apiService.get<ParkingLotDetail>(`ParkingLot/GetParkingLotsById?id=${id}`);
  }

  groupBookParkingSlot(data: any) {
    return this.apiService.post(`GroupBooking/GroupBookParkingSlot`, data)
  }

  calculateFareChargesOfGroupBooking(data: any) {
    return this.apiService.post(`GroupBooking/CalculateFareChargesOfGroupBooking`, data)
  }

  getGroupBookParkingSlot(data: any) {
    return this.apiService.postWithAllResponse(`BookingSlot/GroupBookParkingSlot`, data)
  }

  createGroupBookingPaymentSession(data: any) {
    return this.apiService.post(`/GroupBooking/CreateGroupBookingPaymentSession`, data)
  }

  getVehicleTypeList(): Observable<GroupVehicleTypeDetail[]> {
    return this.apiService.get<GroupVehicleTypeDetail[]>('VehicleType/GetVehicleTypeList');
  }

  getAllBookmarkParkingLotsList() {
    return this.apiService.getWithAllResponse<GroupParkingLot[]>('ParkingLot/getAllBookmarkParkingLotsList')
  }

  groupBookParkingSlotBySuperAdmin(data: any) {
    return this.apiService.post(`GroupBooking/BookGroupParkingSlotBySuperAdmin`, data)
  }

  getCancelbookingById(data: any):Observable<any>{
    return this.apiService.postWithAllResponse(`GroupBooking/CancelGroupBookingById`,data)
  }

  cancelBookingBySuperAdminOneTime(data: any):Observable<any>{
    return this.apiService.postWithAllResponse(`BookingSlot/CancelOneTimeBookingBySuperAdmin`,data)
  }

  cancelOneTimeBookingBySuperAdmin(data: any):Observable<any>{
    return this.apiService.postWithAllResponse(`BookingSlot/CancelOneTimeBooking`,data)
  }

  cancelGroupRecurringBookingBySuperAdmin(bookingIdObj) {
    return this.apiService.postWithAllResponse('GroupBooking/CancelGroupRecurringBookingBySuperAdmin',bookingIdObj);
  }
}
